import { Img, SubTitle, TopButton } from 'components';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Text, RowDiv, SubSection, ColDiv, Div, SubWrap } from 'styles';
import { SubLayout } from 'layout';
import * as S from './TechnologyStyle';

export function Technology({ setRef, langList }) {
  const [list, setList] = useState();
  const [loading, setLoading] = useState(true);
  const [currentNav, setCurrentNav] = useState();
  const location = useLocation();

  useEffect(() => {
    if (langList) {
      setCurrentNav(langList.nav.filter((el) => el.path.includes(location.pathname.split('/')[1]))[0]);
      setList(langList.technology);
      setLoading(false);
    }
  }, [langList]);

  useEffect(() => {
    if (sessionStorage.getItem('currentIndex')) {
      setTimeout(
        () =>
          setRef.current[sessionStorage.getItem('currentIndex')].scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          }),
        300,
      );
    }
  }, [sessionStorage.getItem('currentIndex'), setRef.current]);

  return (
    list && (
      <SubLayout list={list} setRef={setRef} nav={langList.nav}>
        <SubSection $type="tech">
          <SubTitle title={list.title} desc={list.subTitle} type="tech" />
          <Div $padding="0 24px" $mPadding="24px 24px 0">
            <ColDiv $gap={48} $mGap={24} $padding="48px 0 104px" $mPadding="0">
              <S.VideoContainer ref={(el) => (setRef.current[0] = el)}>
                <S.VideoWrapper>
                  <video
                    controls
                    width="100%"
                    height="100%"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                  >
                    <source src={list.video} type="video/mp4" />
                    <track kind="captions" />
                    브라우저가 비디오 태그를 지원하지 않습니다.
                  </video>
                </S.VideoWrapper>
              </S.VideoContainer>
              <S.SubTitle $mGap="8px !important">
                <RowDiv $alignItems="center" $gap={16}>
                  <Text $type="b4" $mType="b7" $color="primary">
                    {list.subject1Desc}
                  </Text>
                  <S.Line />
                </RowDiv>
                <Text $type="h3" $mType="h5" $whiteSpace="pre-wrap">
                  {list.subject1}
                </Text>
              </S.SubTitle>
              <Img src={list.subject1Img} alt="DEP 기반 공기청정기형 축사 악취 저감 시스템 구성도 - 팜인 AeroQbit-A" $height={860} $mHeight="auto" />
            </ColDiv>
            <SubWrap ref={(el) => (setRef.current[1] = el)}>
              <S.SubTitle $mGap="8px !important">
                <RowDiv $alignItems="center" $gap={16}>
                  <Text $type="b4" $mType="b7" $color="primary">
                    {list.subject2Desc}
                  </Text>
                  <S.Line />
                </RowDiv>
                <Text $type="h3" $mType="h5" $whiteSpace="pre-wrap">
                  {list.subject2}
                </Text>
              </S.SubTitle>
              <ColDiv $gap={16}>
                <Img src={list.subject2_1Img} alt="축사 내부 공기 순환 및 악취 저감 시스템 설치 위치·작동 방식" />
                <S.GridDiv>
                  {list.subject2Content.map((item, index) => (
                    <ColDiv key={`item_${index}`} $gap={8}>
                      <Text $type="h4" $mType="h7">
                        {item.title}
                      </Text>
                      {item.desc && (
                        <ul>
                          {item.desc.map((desc, idx) => (
                            <li key={`desc_${idx}`}>
                              <RowDiv $alignItems="center" $tAlignItems="flex-start" $gap={10} $mGap={4}>
                                <S.Circle />
                                <Text $type="b5" $mType="b8" $color="darker">
                                  {desc}
                                </Text>
                              </RowDiv>
                            </li>
                          ))}
                        </ul>
                      )}
                      {item.img && <Img src={item.img} alt={`${item.title} - 축사 악취 저감 작동 효과`} />}
                    </ColDiv>
                  ))}
                </S.GridDiv>
              </ColDiv>
            </SubWrap>
            <SubWrap ref={(el) => (setRef.current[2] = el)}>
              <S.SubTitle>
                <RowDiv $alignItems="center" $gap={16}>
                  <Text $type="b4" $mType="b7" $color="primary">
                    {list.subject3Desc}
                  </Text>
                  <S.Line />
                </RowDiv>
                <Text $type="h3" $mType="h5" $whiteSpace="pre-wrap">
                  {list.subject3}
                </Text>
              </S.SubTitle>
              <ColDiv $gap={8}>
                <Text $type="h4">{list.subject3Content.title}</Text>
                <ul>
                  {list.subject3Content.desc.map((i, index) => (
                    <li key={`i_${index}`}>
                      <RowDiv>
                        <S.Circle />
                        <Text $type="b5" $mType="b8">
                          {i}
                        </Text>
                      </RowDiv>
                    </li>
                  ))}
                </ul>
              </ColDiv>
              <Img src={list.subject3Content.img} alt="AeroQbit-A 축사용 공기청정기 악취 저감 성능 검증 성적서 (희석 배수 85% 저감)" />
            </SubWrap>
            {list.subject4 && (
              <SubWrap ref={(el) => (setRef.current[3] = el)}>
                <S.SubTitle>
                  <RowDiv $alignItems="center" $gap={16}>
                    <Text $type="b4" $mType="b7" $color="primary">
                      {list.subject4Desc}
                    </Text>
                    <S.Line />
                  </RowDiv>
                  <Text $type="h3" $mType="h5" $whiteSpace="pre-wrap">
                    {list.subject4}
                  </Text>
                </S.SubTitle>
                {list.subject4Content && (
                  <ColDiv $gap={32}>
                    {/* 제습 성능 그래프 섹션 */}
                    <ColDiv $gap={16}>
                      <Text $type="h4" $mType="h6">
                        {list.subject4Content.performanceTitle}
                      </Text>
                      <ColDiv $gap={8}>
                        {list.subject4Content.performanceDesc && (
                          <ul>
                            {list.subject4Content.performanceDesc.map((desc, idx) => (
                              <li key={`desc_${idx}`}>
                                <RowDiv $alignItems="center" $tAlignItems="flex-start" $gap={10} $mGap={4}>
                                  <S.Circle />
                                  <Text $type="b5" $mType="b8" $color="darker">
                                    {desc}
                                  </Text>
                                </RowDiv>
                              </li>
                            ))}
                          </ul>
                        )}
                      </ColDiv>
                      {list.subject4Content.performanceImg && (
                        <Img src={list.subject4Content.performanceImg} alt="AeroQbit-D 축사용 제습기 제습 성능 그래프 - 축사 습도 감소" $width="100%" $maxWidth={1083} $height="auto" />
                      )}
                    </ColDiv>
                    {/* 시험성적서 섹션 */}
                    {list.subject4Content.certificationImg && (
                      <ColDiv $gap={16} $width="100%">
                        <Text $type="h4" $mType="h6">
                          시험성적서
                        </Text>
                        <S.CertificationImageWrapper>
                          <Img src={list.subject4Content.certificationImg} alt="AeroQbit-D 축사용 제습기 성능 검증 성적서" $width="100%" $maxWidth={900} $height="auto" />
                        </S.CertificationImageWrapper>
                      </ColDiv>
                    )}
                  </ColDiv>
                )}
              </SubWrap>
            )}
          </Div>
        </SubSection>
      </SubLayout>
    )
  );
}
